import Banner from '../Banner/Banner'
import './Error404.css'
import React from 'react'
import gif from '../images/VA8QxIdIoY.gif'
import { Link } from 'react-router-dom'

function Error404 (){

    return(
        <>
            <Banner title="Page Not Found" smtitle="page not found" />
            <div className='error'>
                <div className='container'>
                    <h1>4<img src={gif}/>4</h1>
                    <h2>The Page you were looking for, couldn't be found.</h2>
                    <p>The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
                    <Link to="/home"><button>Return To Home</button></Link>
                </div>
            </div>
        </>
    )
}
export default Error404;